/*******************************************************************************
* Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
*                 This work contains trade secrets and confidential materials
*                 of Honeywell Inc., and its use or disclosure in whole or in
*                 part without express written permission of Honeywell Inc.
*                 is prohibited.
*
* Name          : NonMSAKeyOnlyConfigSummary.tsx
*
* Project Title : Checkout
*
* Description   : Initial version
*
* Company       : Honeywell Technology Solutions , Hyderabad
*
* @Author       : H422337
*
* @Date         : Oct,08 2020
*
* @Version      : Version 1.0
*
******************************************************************************/
import * as React from 'react';
import { Grid, Card, Icon } from '@scuf/common';
import { DataTable } from '@scuf/datatable';
import '@scuf/common/honeywell/theme.css';
import './ConfigureAPU.css';
import { ICellData } from '@scuf/datatable/dist/components/DataTable/IDataTableInterfaces';

function unitPriceRenderer(cellData: ICellData) {
    return <span>{`$${cellData.value.toFixed(2)}`}</span>;
}

function NonMSAKeyOnlyConfigSummary(props: any) {
    return (
        <Card className="fullwidthCard margin-top-0 config-confirmation-card-spacing">
            <Card.Content>
                <Grid>
                    <Grid.Row className="dispayProductCard">
                        <Grid.Column width={11} className="fullwidthRow">
                            <span className="confirmation-title-text">Confirm Configuration</span>
                        </Grid.Column>
                        <Grid.Column width={1} className="fullwidthRow">
                            <div className="pull-right">
                                <Icon
                                    root="common"
                                    name="edit"
                                    size="small"
                                    className="confirmation-edit-icon"
                                    onClick={props.gotoProductConfigureTab}
                                />
                            </div>
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                        <Grid.Column width={12} className="fullwidthRow">
                            <div>
                                <DataTable
                                    data={props.productData}
                                    scrollable={true}
                                    scrollHeight="150px"
                                    virtualRowHeight={48}
                                    resizableColumns={true}
                                >
                                    <DataTable.Column field="serialNumber" header="APU Serial No." align="left" editable={false} />
                                    <DataTable.Column field="optionName" header="Subscription Period" align="left" editable={false} />
                                    <DataTable.Column field="unitPrice" header="Unit Price" align="left" editable={false} renderer={unitPriceRenderer}/>
                                </DataTable>
                            </div>

                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </Card.Content>
        </Card>
    );
}

export default (NonMSAKeyOnlyConfigSummary);
